export default __webpack_public_path__ + "static/icon-b22692c3650f0d581486fab505558477.png";